import React from 'react';

const Section = ({ children }) => <div className='panel__section'>{children}</div>;

export default Section;
